import { Extension } from '@tiptap/react';
import { checkContentForImages, checkContentForUploadingImage, processInternalLinks } from '../../utils/editorContentOperations';

const createSubmitCommand = (that) => {
  return ({ editor }) => {
    const rawHtml = editor.getHTML();
    const hasImageUploadingInProgress = checkContentForUploadingImage(rawHtml);
    const hasImg = checkContentForImages(rawHtml)
    const processedHtml = processInternalLinks(rawHtml);
    const trimmedTextContent = editor.getText().trim();
    if (!hasImageUploadingInProgress) {
      that?.storage?.submitFn?.(processedHtml, trimmedTextContent || hasImg);
    }
    return true;
  };
};

export default Extension.create({
  name: 'onSubmitExtension',
  addStorage() {
    return {
      submitFn: this.options.onSubmit,
    }
  },
  addCommands() {
    return {
      submit: () =>
        createSubmitCommand(this),
      updatesubmitfn: (onsubmit) => () => {
        this.storage.submitFn = onsubmit;
        return true;
      },
    };
  },
  addKeyboardShortcuts() {
    return {
      'Ctrl-Enter': () => this.editor.commands.submit(),
      'Cmd-Enter': () => this.editor.commands.submit(),
    };
  },
});
